export const sectors = [
    "Accounting and Finance",
    "Agriculture & Farming",
    "Arts & Creative",
    "Business Services",
    "Construction & Property",
    "Education & Training",
    "Energy & Environment",
    "Engineering & Manufacturing",
    "Food & Beverage",
    "Government & Public Services",
    "Healthcare & Medical",
    "Hospitality & Tourism",
    "HR & Recruitment",
    "Insurance",
    "Legal & Compliance",
    "Marketing, Advertising & Digital",
    "Other",
    "Sports, Media & Entertainment",
    "Retail & E-Commerce",
    "Sales & Customer Service",
    "Science & Research",
    "Technology & IT",
    "Telecommunication",
    "Third Sector",
    "Transport & Logistics",
  ];